import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function amountValidator(min: number | null, max?: number | null): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (min && Number(control.value) < min) {
            return { amountToLow: { min } };
        } else if (max && Number(control.value) > max) {
            return { amountTooHigh: { max } };
        } else {
            return null;
        }
    };
}
